import { RootState } from "../../store/reducers";
export const cryptoSelector = (state: RootState) => state.crypto;
export const getAccountsListSelector = (state: RootState) => state.crypto.getAccountsList;
export const coingeckoMarketChartsSelector = (state: RootState) => state.crypto.coingeckoMarketCharts;
export const exchangeFromCoinSelector = (state: RootState) => state.crypto.exchangeFromCoin;
export const exchangeToCoinSelector = (state: RootState) => state.crypto.exchangeToCoin;